import { ServiceFactory } from "@rsm-hcd/javascript-react";
import RemoteAccessDetailsRecord from "models/view-models/remote-access-details-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";

export interface SharedPageRecipientAccessResourcePathParams {
    pageGuid: string;
}
export interface SharedPageRecipientAccessQueryParams {
    recipientGuid?: string;
    storageContainer?: string;
    relativeProviderPath?: string;
}

const endpoint: string = "shared/pages/:pageGuid/remoteaccessdetails";
const resourceType = RemoteAccessDetailsRecord;

const SharedPageRemoteAccessDetailsService = {
    /**
     * Get a PreSignedUrl to an S3 resource
     */
    get: ServiceFactory.get<
        RemoteAccessDetailsRecord,
        SharedPageRecipientAccessResourcePathParams,
        SharedPageRecipientAccessQueryParams
    >(resourceType, endpoint),

    useGetQuery: QueryHookFactory.useGetQuery<
        RemoteAccessDetailsRecord,
        SharedPageRecipientAccessResourcePathParams,
        SharedPageRecipientAccessQueryParams
    >("sharedPageRemoteAccessDetails", resourceType, endpoint),
};

export default SharedPageRemoteAccessDetailsService;
